import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function MetaTagGenerator() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [keywords, setKeywords] = useState("");
  const [url, setUrl] = useState("");
  const [metaTags, setMetaTags] = useState("");

  const generateMetaTags = () => {
    const tags = `
<!-- SEO Meta Tags -->
<title>${title}</title>
<meta name="description" content="${description}" />
<meta name="keywords" content="${keywords}" />
<link rel="canonical" href="${url}" />
<meta property="og:title" content="${title}" />
<meta property="og:description" content="${description}" />
<meta property="og:url" content="${url}" />
<meta name="twitter:title" content="${title}" />
<meta name="twitter:description" content="${description}" />
`.trim();
    setMetaTags(tags);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(metaTags).then(() => {
      alert("Meta tags copied to clipboard!");
    });
  };

  return (
    <>
      <Helmet>
        <title>Meta Tag Generator - Free SEO Tool for Website Optimization</title>
        <meta
          name="description"
          content="Instantly generate SEO meta tags for your website. Input title, description, and keywords to get the perfect meta tags for better search engine ranking."
        />
        <meta name="keywords" content="meta tag generator, seo meta tags, generate meta tags, seo tool, free seo tool, meta tags for website" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/meta-tag-generator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Meta Tag Generator Tool</h2>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Page Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Page Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Keywords (comma-separated)"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
          />
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Canonical URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />

          <button className="btn btn-primary mb-3" onClick={generateMetaTags}>
            Generate Meta Tags
          </button>

          {metaTags && (
            <>
              <textarea
                className="form-control mb-3"
                rows="10"
                readOnly
                value={metaTags}
              />
              <button className="btn btn-success" onClick={copyToClipboard}>
                Copy Tags
              </button>
            </>
          )}
        </div>
      </section>
    </>
  );
}
